import ConversationsMenu from '@/components/scaffold/sidebar/sidebar-views/ConversationsMenu';
import { EmptyState } from '@/components/ui/empty-state';
import { useSentBatchesQuery } from '@/hooks/queries/use-sent-batches-query';
import { Flex, useBreakpointValue } from '@chakra-ui/react';
import { Mail, MessageText, Search } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const DesktopUnselectedMessageThread = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const isSentTab = searchParams.get('messageFilter') === 'sent';
  const searchQuery = searchParams.get('search') ?? '';
  const { data, isLoading } = useSentBatchesQuery(
    { search: searchQuery || undefined },
    { enabled: isSentTab }
  );
  const hasNoSentEmails = isSentTab && !isLoading && (data?.data.length ?? 0) === 0;

  const title = hasNoSentEmails
    ? t(searchQuery ? 'messages.sentTab.noSearchResults' : 'messages.sentTab.emptyState')
    : t('messages.thread.unselectedTitle');
  const description = hasNoSentEmails
    ? t(searchQuery ? 'messages.sentTab.noSearchDescription' : 'messages.sentTab.emptyDescription')
    : t('messages.thread.unselectedDescription');
  const icon = hasNoSentEmails ? (
    searchQuery ? (
      <Search width={24} height={24} />
    ) : (
      <Mail width={24} height={24} />
    )
  ) : (
    <MessageText width={24} height={24} />
  );

  return (
    <Flex justify="center" align="center" h="full">
      <EmptyState
        alignItems="center"
        bare
        display="flex"
        h="full"
        justifyContent="center"
        title={title}
        description={description}
        icon={icon}
      />
    </Flex>
  );
};

const UnselectedMessageThreadPage = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  if (isMobile) {
    return <ConversationsMenu />;
  }

  return <DesktopUnselectedMessageThread />;
};

export default UnselectedMessageThreadPage;
